
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_1diry_161",
  "refresh": "awsui_refresh_8cbea_1diry_187",
  "disabled": "awsui_disabled_8cbea_1diry_193",
  "selected": "awsui_selected_8cbea_1diry_256",
  "icon": "awsui_icon_8cbea_1diry_279",
  "with-text": "awsui_with-text_8cbea_1diry_283",
  "with-no-text": "awsui_with-no-text_8cbea_1diry_289",
  "root": "awsui_root_8cbea_1diry_294",
  "segment-part": "awsui_segment-part_8cbea_1diry_326",
  "select": "awsui_select_8cbea_1diry_256",
  "segment-count-2": "awsui_segment-count-2_8cbea_1diry_362",
  "segment-count-3": "awsui_segment-count-3_8cbea_1diry_366",
  "segment-count-4": "awsui_segment-count-4_8cbea_1diry_370",
  "segment-count-5": "awsui_segment-count-5_8cbea_1diry_374",
  "segment-count-6": "awsui_segment-count-6_8cbea_1diry_378",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_1diry_382"
};
  